<div class="row">
	<div class="col-lg-6 d-flex">
		<span data-testid="SUBSYS5_PATLIST_RESULTS_TXT" class="results">
			{{ collectionSize() }} {{ labels().PATIENT_TABLE_COMPONENT_RESULTS }}
		</span>
	</div>
</div>

<tsp-patient-table [patients]="items()" [hasPlanDetails]="true" [isFiltersCollapsed]="isFiltersCollapsed()"
	[sortOrder]="sortOrder()" (sortOrderChange)="updateSortOrder($event)" />

<div class="row mt-5">
	<div class="col">
		<tsp-pagination [collectionSize]="collectionSize()" [(page)]="pageNumber" (pageChange)="updatePageNumber()"
			[(pageSize)]="pageSize" (pageSizeChange)="updatePageSize()" />
	</div>
</div>